import React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { CuotasMensuales } from './CuotasMensuales';
import { Matriculas } from './Matricula';
import { Seguros } from './Seguros';

function TabPanel(props: { [x: string]: any; children: any; value: any; index: any; }) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>{children}</>
      )}
    </div>
  );
}

export function Cuotas() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: any, newValue: React.SetStateAction<number>) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={value} onChange={handleChange}>
        <Tab label="Cuotas" />
        <Tab label="Matriculas" />
      </Tabs>
      <TabPanel value={value} index={0}>
        <CuotasMensuales />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Matriculas />
      </TabPanel>
    </Box>
  );
}
